<div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px" class="frame-details-layout" [formGroup]="orderForm">
	<div fxFlex formArrayName="products">


				<div fxLayout="column" fxLayoutAlign="left" fxLayoutGap="0px" style="width:100%" formGroupName="0">

				    <div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="10px" class="frame-top-row">
				      <div class="frame-pof-field" fxFlex="0 0 40px">
				      	<label class="frame-pof-label">POF</label>
				        <mat-checkbox [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['pof']"></mat-checkbox>
				      </div>
				      <div fxFlex="2 1 0" class="frame-field-stretch frame-manufacturer-field">
							<app-autocomplete-vendors 
						    	placeholder="MANUFACTURER" 
						  		[storeOnly]="true"
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
						    	fxFlex="1 1 100%"></app-autocomplete-vendors>
				      </div>
				      <div fxFlex="1 1 0" class="frame-field-stretch">
				      	<app-autocomplete-vendor-products
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
					  			[(vendor)]="orderForm.controls.products['controls'][0]['controls']['product']['value']['vendor']" 
					  			placeholder="MODEL"
					  			(selected)="onProductFieldSelected($event)"
					  			displayField="model"
								fxFlex="1 1 100%">
							</app-autocomplete-vendor-products>
				      </div>
				      <div fxFlex="1 1 0" class="frame-field-stretch">
				      	<app-autocomplete-vendor-products
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
					  			[(vendor)]="orderForm.controls.products['controls'][0]['controls']['product']['value']['vendor']" 
					  			placeholder="COLOR"
					  			(selected)="onProductFieldSelected($event)"
					  			displayField="color"
								fxFlex="1 1 100%">
							</app-autocomplete-vendor-products>
				      </div>
				      <div fxFlex="0 0 100px" class="frame-field-fixed">
				      	<app-autocomplete-vendor-products
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
					  			[(vendor)]="orderForm.controls.products['controls'][0]['controls']['product']['value']['vendor']" 
					  			placeholder="SIZE"
					  			(selected)="onProductFieldSelected($event)"
					  			displayField="size"
								fxFlex="1 1 100%">
							</app-autocomplete-vendor-products>
				      </div>
				      <div fxFlex="0 0 100px" class="frame-field-fixed">
				      	<mat-form-field fxFlex="1 1 100%">
									<mat-select placeholder="TYPE" [formControl]="orderForm.controls.products['controls'][0]['controls']['product']['controls']['type']">
										<mat-option *ngFor="let typeOption of typeOptions" [value]="typeOption.value">
											{{typeOption.viewValue}}
										</mat-option>
									</mat-select>
				        </mat-form-field>
				      </div>
				      <div fxFlex="0 0 50px">
				        <mat-form-field style="width:100%">
				          <input matInput placeholder="QTY" type="" autocomplete="off" formControlName="quantity">
				        </mat-form-field>
				      </div>
				      <div fxFlex="0 0 75px" class="frame-spc-order">
				      	<label>SPC ORDER</label>
				      	<mat-checkbox aria-label="SPC ORDER" [formControl]="orderForm.controls.specialOrder"></mat-checkbox>
				      </div>
				    </div>

				    <div class="frame-status-grid">
				    	<div class="frame-status-grid-row">
							<mat-form-field class="frame-date-field" appearance="standard">
							  <mat-label>ORDER DATE</mat-label>
							  <input matInput [matDatepicker]="pickerOrderDate" [formControl]="orderForm.controls.date">
							  <mat-datepicker-toggle matSuffix [for]="pickerOrderDate"></mat-datepicker-toggle>
							  <mat-datepicker #pickerOrderDate></mat-datepicker>
							</mat-form-field>
							<mat-form-field class="frame-status-field" appearance="standard" formGroupName="frame">
							  <mat-label>FRAME STATUS</mat-label>
							  <mat-select formControlName="preOrderStatus">
							    <mat-option *ngFor="let option of preOrderStatusOptions" [value]="option">
							      {{ option }}
							    </mat-option>
							  </mat-select>
							</mat-form-field>
					    	<div class="frame-status-right-col frame-measurements-row">
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">A</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['a']" (input)="onMeasurementInput($event, 'a')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">B</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['b']" (input)="onMeasurementInput($event, 'b')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">ED</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['ed']" (input)="onMeasurementInput($event, 'ed')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">DBL</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['dbl']" (input)="onMeasurementInput($event, 'dbl')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					    	</div>
				    	</div>

				    	<div class="frame-status-grid-row">
							<mat-form-field class="frame-date-field" appearance="standard" formGroupName="frame">
							  <mat-label>DATE RECEIVED</mat-label>
							  <input matInput [matDatepicker]="pickerDateReceived" formControlName="dateReceived">
							  <mat-datepicker-toggle matSuffix [for]="pickerDateReceived"></mat-datepicker-toggle>
							  <mat-datepicker #pickerDateReceived></mat-datepicker>
							</mat-form-field>
							<mat-form-field class="frame-status-field" appearance="standard">
							  <mat-label>FRAME STATUS</mat-label>
							  <mat-select [formControl]="orderForm.controls.status">
							    <mat-option *ngFor="let option of frameStatusSelectOptions" [value]="option">
							      {{ option }}
							    </mat-option>
							  </mat-select>
							</mat-form-field>
					    	<div class="frame-status-right-col frame-checkbox-row">
	      						<mat-checkbox class="frame-inline-checkbox" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['nosepadInstall']">NOSEPADS INSTALL</mat-checkbox>
	      						<mat-checkbox class="frame-inline-checkbox" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['duty']">DUTY</mat-checkbox>
	      						<mat-checkbox class="frame-inline-checkbox" [formControl]="orderForm.controls.products['controls'][0]['controls']['lens']['controls']['drill']">DRILL MOUNT</mat-checkbox>
					    	</div>
				    	</div>

				    	<div class="frame-status-grid-row">
							<mat-form-field class="frame-date-field" appearance="standard" formGroupName="frame">
							  <mat-label>{{ followUpDateLabel }}</mat-label>
							  <input matInput [matDatepicker]="pickerDateReturned" formControlName="followUpDate">
							  <mat-datepicker-toggle matSuffix [for]="pickerDateReturned"></mat-datepicker-toggle>
							  <mat-datepicker #pickerDateReturned></mat-datepicker>
							</mat-form-field>
							<mat-form-field class="frame-status-field" appearance="standard" formGroupName="frame">
							  <mat-label>FRAME STATUS</mat-label>
							  <mat-select formControlName="followUpStatus">
							    <mat-option *ngFor="let option of followUpStatusOptions" [value]="option">
							      {{ option }}
							    </mat-option>
							  </mat-select>
							</mat-form-field>
					    	<div class="frame-status-right-col frame-part-other" formGroupName="frame">
	      						<mat-checkbox formControlName="partOther" class="frame-part-other-checkbox"></mat-checkbox>
	      						<mat-form-field appearance="standard" class="frame-part-other-description">
						         	<mat-label>PART/OTHER</mat-label>
						         	<input matInput type="" autocomplete="off" formControlName="partOtherDescription">
						        </mat-form-field>
	      						<mat-form-field appearance="standard" class="frame-part-other-price">
					         		<input matInput placeholder="" type="" autocomplete="off" formControlName="partOtherPrice" (input)="updateCustomAmount()" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['frame']['controls']['partOtherPrice']); updateCustomAmount()">
					         		<span matPrefix>$&nbsp;</span>
				        		</mat-form-field>
					    	</div>
				    	</div>
				    </div>
					<div class="frame-notes" formGroupName="frame">
					  <label class="frame-notes-label">FRAME NOTES</label>
					  <div class="frame-notes-history" *ngIf="frameNoteEntries.length">
					    <div class="frame-note-entry" *ngFor="let entry of frameNoteEntries">
					      <div class="frame-note-meta" *ngIf="!entry.legacy">
					        {{ entry.timestamp }} &ndash; {{ entry.initials }}
					      </div>
					      <div class="frame-note-meta frame-note-meta-legacy" *ngIf="entry.legacy">
					        Previous notes
					      </div>
					      <div class="frame-note-text">{{ entry.text }}</div>
					    </div>
					  </div>
					  <mat-form-field appearance="fill" class="frame-notes-field">
					    <mat-label>Add note</mat-label>
					    <textarea
					      matInput
					      rows="3"
					      [value]="frameNoteDraft"
					      (input)="frameNoteDraft = $any($event.target).value"
					      (keydown.control.enter)="appendFrameNote()"
					    ></textarea>
					  </mat-form-field>
					  <div class="frame-notes-actions">
					    <button
					      mat-stroked-button
					      type="button"
					      (click)="appendFrameNote()"
					      [disabled]="!canAppendFrameNote"
					    >
					      ADD NOTE
					    </button>
					  </div>
					</div>

				</div>

      </div>
      <div fxFlex="0 0 225px" class="frame-details-sidebar">
  			<mat-card class="frame-thumbnail-card">
  				<mat-card-content class="frame-thumbnail-box">
					<app-image
						*ngIf="frameImages?.length; else frameImageUpload"
						[image]="frameImages[0]"
						[tmp]="false"
						type="product"
						[productId]="selectedProductId"
						[edit]="true"
						[delete]="true"
						[active]="true"
						(imageDelete)="onFrameImageDelete($event)"
						(imageReplace)="onFrameImageReplace($event)"
					></app-image>
					<ng-template #frameImageUpload>
						<app-image
							type="product"
							[upload]="true"
							[autoCrop]="true"
							[active]="true"
							[productId]="selectedProductId"
							(imageAdd)="onFrameImageAdd($event)"
						></app-image>
					</ng-template>
  				</mat-card-content>
  			</mat-card>
  			<mat-card class="frame-pricing-box">
  				<mat-card-content>
		  			<mat-form-field style="width:100%">
		          <input matInput placeholder="TAX" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['tax']" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['tax']); updateSubtotal()">
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		  			<mat-form-field style="width:100%">
		          <input matInput placeholder="FRAME" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['retail']" [readonly]="isPofSelected" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['retail']); updateSubtotal()">
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		  			<mat-form-field style="width:100%">
		          <input matInput placeholder="CUSTOM" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['custom']" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['custom']); updateSubtotal()">
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		        <mat-form-field style="width:100%">
		          <input matInput placeholder="SUBTOTAL" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['subtotal']" readonly>
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		      </mat-card-content>
		    </mat-card>

		    <mat-card style="margin-top:10px;" class="order-commit-card">
				<mat-card-content class="order-commit-card-content">

					<app-last-editor-field [orderForm]="orderForm"></app-last-editor-field>

	  			<mat-form-field class="order-initials-field" floatLabel="never">
			      <input matInput required placeholder="" type="text" formControlName="initials">
			      <mat-label><mat-icon>gesture</mat-icon></mat-label>
			    </mat-form-field>

			    <button
			      mat-raised-button
			      color="primary"
			      type="button"
			      class="order-post-button"
			      (click)="onPost()"
			      [disabled]="!orderForm.get('initials')?.value"
			    >
			      POST
			    </button>

			    <app-order-save-menu [orderForm]="orderForm" (saveOrder)="onSave($event.destination)"></app-order-save-menu>

	      </mat-card-content>
	    </mat-card>
   		</div>
    </div>